import { ButtonBase, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';

export const UploadPicture = (props) => {
  const { uploadPicture, initialFile } = props;
  const [file, setFile] = useState(initialFile);
  const { t } = useTranslation();

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      uploadPicture({});

      return;
    }

    const fileURL = URL.createObjectURL(selectedFile);
    const fileData = {
      src: fileURL,
      name: selectedFile.name,
      extension: selectedFile.name.split('.').pop(),
      lastModifiedDate: new Date(
        selectedFile.lastModified
      ).toLocaleDateString(),
      lastModifiedTime: new Date(
        selectedFile.lastModified
      ).toLocaleTimeString(),
      originalFile: selectedFile,
    };
    uploadPicture(fileData);

    setFile(fileData);
  };

  return (
    <>
      {!file ? (
        <label>
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={handleFileChange}
            id="upload-picture"
          />
          <ButtonBase
            onClick={() => {
              let elt = document.getElementById('upload-picture');
              if (elt) elt.click();
            }}
            sx={{
              height: '92px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              cursor: 'pointer',
              width: '100%',
              border: '1px solid #44546A',
              borderRadius: '4px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '9.65px',
              }}
            >
              {' '}
              <div
                style={{
                  width: '22px',
                  height: '21.5px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                >
                  <path
                    d="M17.0835 21.75H6.0907C5.44997 21.7974 4.80591 21.7168 4.19976 21.5132C3.59362 21.3096 3.03876 20.9875 2.57071 20.5677C2.10267 20.1478 1.73176 19.6394 1.48173 19.075C1.23171 18.5106 1.10808 17.9026 1.11878 17.29L0.573334 9.04C0.529378 8.42669 0.619492 7.81136 0.837969 7.23298C1.05645 6.6546 1.39852 6.12578 1.84254 5.68C2.28486 5.22963 2.81926 4.87041 3.41277 4.62447C4.00629 4.37853 4.64636 4.25109 5.29352 4.25C5.46391 4.24769 5.63035 4.20075 5.77464 4.11433C5.91894 4.02791 6.03554 3.90534 6.11168 3.76L6.86691 2.33C7.221 1.7267 7.7303 1.21922 8.34687 0.855336C8.96344 0.491455 9.667 0.283139 10.3913 0.25L12.7934 0.25C13.5149 0.283404 14.2158 0.490835 14.8304 0.85287C15.445 1.21491 15.9531 1.7197 16.3073 2.32L17.0625 3.78C17.1421 3.92111 17.2601 4.0392 17.404 4.1219C17.548 4.20459 17.7126 4.24884 17.8807 4.25C18.528 4.25095 19.1683 4.37833 19.762 4.62427C20.3557 4.87022 20.8903 5.22951 21.3327 5.68C21.776 6.12627 22.1176 6.65516 22.336 7.23342C22.5544 7.81167 22.645 8.42677 22.6019 9.04L22.0565 17.3C22.0721 17.9136 21.9516 18.5234 21.7031 19.0895C21.4545 19.6556 21.0834 20.1654 20.614 20.5854C20.1446 21.0055 19.5875 21.3263 18.9791 21.527C18.3708 21.7277 17.7248 21.8037 17.0835 21.75ZM10.3913 1.75C9.95841 1.77938 9.53945 1.90847 9.1704 2.12619C8.80134 2.34391 8.49322 2.64376 8.27248 3L7.51725 4.44C7.30913 4.83245 6.99134 5.16246 6.59894 5.39362C6.20654 5.62479 5.75478 5.74812 5.29352 5.75C4.86115 5.74933 4.43324 5.8333 4.03629 5.99671C3.63935 6.16012 3.28183 6.39949 2.98587 6.7C2.69063 6.99743 2.46356 7.35019 2.31909 7.73583C2.17462 8.12147 2.11592 8.53156 2.14673 8.94L2.69217 17.2C2.66599 17.6236 2.73764 18.0475 2.90206 18.4419C3.06648 18.8362 3.31968 19.1913 3.64378 19.4822C3.96788 19.773 4.35498 19.9926 4.77778 20.1252C5.20057 20.2579 5.64876 20.3005 6.0907 20.25H17.0835C17.5254 20.3005 17.9736 20.2579 18.3964 20.1252C18.8192 19.9926 19.2063 19.773 19.5304 19.4822C19.8545 19.1913 20.1077 18.8362 20.2721 18.4419C20.4366 18.0475 20.5082 17.6236 20.482 17.2L21.0275 8.94C21.0557 8.53014 20.9951 8.11914 20.8496 7.73255C20.704 7.34596 20.4766 6.99205 20.1815 6.69285C19.8863 6.39364 19.5297 6.15553 19.1339 5.99332C18.7381 5.83112 18.3115 5.7483 17.8807 5.75C17.422 5.7479 16.9727 5.6267 16.5809 5.39942C16.1891 5.17213 15.8697 4.84736 15.6569 4.46L14.8912 3C14.6715 2.64593 14.3648 2.34808 13.9975 2.13207C13.6302 1.91606 13.2134 1.78838 12.7829 1.76H10.3913V1.75Z"
                    fill="#44546A"
                  />
                  <path
                    d="M13.1603 7.75H10.0135C9.80528 7.74869 9.60598 7.66925 9.45874 7.52888C9.31151 7.38851 9.22818 7.19851 9.22681 7C9.22818 6.80149 9.31151 6.61149 9.45874 6.47112C9.60598 6.33075 9.80528 6.25131 10.0135 6.25H13.1603C13.3685 6.25131 13.5678 6.33075 13.7151 6.47112C13.8623 6.61149 13.9456 6.80149 13.947 7C13.9456 7.19851 13.8623 7.38851 13.7151 7.52888C13.5678 7.66925 13.3685 7.74869 13.1603 7.75Z"
                    fill="#44546A"
                  />
                  <path
                    d="M11.5868 17.75C10.757 17.75 9.9458 17.5154 9.25582 17.0759C8.56583 16.6364 8.02806 16.0116 7.7105 15.2807C7.39293 14.5498 7.30984 13.7456 7.47173 12.9696C7.63363 12.1937 8.03323 11.481 8.62001 10.9216C9.20679 10.3622 9.9544 9.9812 10.7683 9.82686C11.5822 9.67252 12.4258 9.75173 13.1925 10.0545C13.9591 10.3572 14.6144 10.8699 15.0754 11.5277C15.5365 12.1855 15.7826 12.9589 15.7826 13.75C15.7826 14.8109 15.3405 15.8283 14.5537 16.5784C13.7668 17.3286 12.6996 17.75 11.5868 17.75ZM11.5868 11.25C11.0682 11.25 10.5612 11.3966 10.1299 11.6713C9.69871 11.946 9.3626 12.3365 9.16412 12.7933C8.96564 13.2501 8.91371 13.7528 9.0149 14.2377C9.11608 14.7227 9.36583 15.1681 9.73257 15.5178C10.0993 15.8674 10.5666 16.1055 11.0752 16.202C11.5839 16.2984 12.1112 16.2489 12.5904 16.0597C13.0695 15.8705 13.4791 15.5501 13.7672 15.1389C14.0554 14.7278 14.2092 14.2445 14.2092 13.75C14.2092 13.087 13.9329 12.4511 13.4411 11.9822C12.9493 11.5134 12.2823 11.25 11.5868 11.25Z"
                    fill="#44546A"
                  />
                </svg>
              </div>
              <Typography
                sx={{ fontSize: '16px', fontWeight: '700', lineHeight: '21px' }}
              >
                {t('submitPage.scanthecode')}
              </Typography>
            </div>
          </ButtonBase>
        </label>
      ) : (
        <div
          style={{
            height: '68px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '15px',
            padding: '12px',
            background: 'white',
          }}
        >
          <div
            style={{
              width: '69px',
              height: '69px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src={file.src}
              alt="Uploaded"
              style={{
                maxHeight: '69px',
                maxWidth: '69px',
                objectFit: 'contain',
              }}
            />
          </div>
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '2px',
              alignItems: 'flex-start',
            }}
          >
            <Typography
              sx={{
                lineHeight: '26px',
                fontSize: '17px',
                fontWeight: '700',
                whiteSpace: 'nowrap',
              }}
            >
              {file.name?.length > 12
                ? file.name?.substring(0, 12) + '(...)'
                : file.name}{' '}
              <span style={{ color: '#9CA0AB' }}>.{file.extension}</span>
            </Typography>
            <Typography
              sx={{ lineHeight: '18px', fontSize: '12px', fontWeight: '400' }}
            >
              {file?.lastModifiedDate} {file?.lastModifiedTime}
            </Typography>
          </div>
          <IconButton
            onClick={() => {
              setFile(undefined);
              uploadPicture(undefined);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="23"
              viewBox="0 0 21 23"
              fill="none"
            >
              <path
                d="M7 12L13 12"
                stroke="#9CA0AB"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 15H11"
                stroke="#9CA0AB"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 5H6.5M19.5 5H14M6.5 5V3.5C6.5 2.39543 7.39543 1.5 8.5 1.5H12C13.1046 1.5 14 2.39543 14 3.5V5M6.5 5H14"
                stroke="#9CA0AB"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.5 8L3.92867 19.574C3.96848 20.649 4.85153 21.5 5.9273 21.5H14.5727C15.6485 21.5 16.5315 20.6491 16.5713 19.574L17 8"
                stroke="#9CA0AB"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconButton>
        </div>
      )}
    </>
  );
};
